import { createAsyncThunk } from "@reduxjs/toolkit";
import { showAlert } from "../slices/features/alert";
import { getBaseUrl } from "../selectors/features";
import { UserProfileService } from "@root/services/user-profile-change";
import { UPLOAD_FILE, USER_PROFILE } from "../action-types/userProfile";
import { TOAST_VARIANT } from "@root/constants/common";
import { t } from "i18next";
import { getLoggedInUser } from "../selectors/entities";

const userProfileService = new UserProfileService();

interface UserProfilePayload {
  payload: any;
  fullname: any;
  introduction: any;
  selectedFile: any;
  onSuccess: any;
  onError: any;
  disableAlert?: boolean
}

export const userProfile = createAsyncThunk<TObject, TObject, IActionOptions>(
  USER_PROFILE,
  async (requestPayload: UserProfilePayload, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const userProfile: any = getLoggedInUser(thunkAPI.getState());
    let updatedUser = {};
    const { payload, disableAlert, onError, onSuccess } = requestPayload;
    const {
      fullname,
      bio,
      selectedFile,
      ai_data_retention,
      default_theme,
      preferred_language,
      avatar
    } = payload;
    const formData: allAnyTypes = new FormData();
    if (ai_data_retention || ai_data_retention === false) {
      formData.append("ai_data_retention", ai_data_retention);
    }
    if (default_theme) {
      formData.append("default_theme", default_theme);
    }
    if (preferred_language) {
      formData.append("preferred_language", preferred_language);
    }
    if (bio) {
      formData.append("bio", bio);
    }
    if (fullname) {
      formData.append("fullname", fullname);
    }
    if (selectedFile) {
      formData.append("file", selectedFile);
    }
    if (avatar || avatar === '') {
      formData.append("avatar", avatar);
    }

    const { data, error } = await userProfileService.userProfile(
      baseUrl,
      formData
    );

    if (error) {
      onError()
      thunkAPI.dispatch(
        showAlert({
          message:
            data?.message || data?.userMessage || data?.code || data || "",
          type: TOAST_VARIANT.ERROR,
        })
      );
      return thunkAPI.rejectWithValue(data);
    } else {
      onSuccess()
      if (!disableAlert) {
        thunkAPI.dispatch(
          showAlert({
            message: t("common:profile.profileUpdate"),
            type: TOAST_VARIANT.SUCCESS,
          })
        );
      }
      updatedUser = {
        ...userProfile,
        user: {
          ...userProfile.user,
          ...(selectedFile && { avatar: data }),
          ...(fullname && { fullname }),
          ...(preferred_language && { preferred_language }),
          ...(default_theme && { default_theme }),
          ...((ai_data_retention === true || ai_data_retention === false) && { ai_data_retention: ai_data_retention }),
          ...(bio && { bio }),
        },
      };
    }

    return thunkAPI.fulfillWithValue(updatedUser);
  }
);

export const uploadFile = createAsyncThunk<TObject, TObject, IActionOptions>(
  UPLOAD_FILE,
  async (requestPayload: any, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { onError, onSuccess, payload, pid } = requestPayload;
    const { data, error } = await userProfileService.uploadFile(baseUrl, payload, pid);

    if (error) {
      onError(error, UPLOAD_FILE , data);
      return thunkAPI.rejectWithValue(error);
    } else {
      onSuccess(data, UPLOAD_FILE);
    }
    return thunkAPI.fulfillWithValue(data);
  }
);
